// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"98":"2ce154c12b5382a58f5d","537":"d1c959864004658b18e3","556":"5944cacdfa418e60f816"}[chunkId] + ".js";
};